/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Supervizor APIs
 * Here is the list of the API endpoints of Supervizor. Click on one to display its implementation. 

Some APIs are protected and require a Bearer token in the Authorization header
 * OpenAPI spec version: 1.0
 */

/**
 * Must be either "COMPANY" or "COMPANY_GROUP"
 */
export type ObjectDtoType = typeof ObjectDtoType[keyof typeof ObjectDtoType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ObjectDtoType = {
  COMPANY: 'COMPANY',
  COMPANY_GROUP: 'COMPANY_GROUP',
} as const;
